import { Routes } from '@angular/router';
import { IMode } from '@models';
import { WarrantyComponent } from './components';
import { AuthorizationGuard } from './guards';
import { WarrantyResolver } from './resolvers';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'admin',
    loadComponent: () => import('./components/admin/admin.component').then(m => m.AdminComponent),
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'admin/damage-report',
    loadComponent: () => import('./components/damage-report/damage-report.component').then(m => m.DamageReportComponent),
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'warranty',
    loadComponent: () => import('./components/warranty-link/warranty-link.component').then(m => m.WarrantyLinkComponent),
  },
  {
    path: 'warranty/legacy/:registrationId',
    loadComponent: () => import('./components/legacy-warranty-link/legacy-warranty-link.component').then(m => m.LegacyWarrantyLinkComponent),
  },
  {
    path: 'warranty/legacy/:registrationId/:claimId',
    loadComponent: () => import('./components/legacy-warranty-link/legacy-warranty-link.component').then(m => m.LegacyWarrantyLinkComponent),
  },
  {
    path: 'warranty/registration/:registrationId/:claimId',
    component: WarrantyComponent,
    data: { mode: IMode.Registration },
    resolve: { warranty: WarrantyResolver },
  },
  {
    path: 'warranty/registration/:registrationId',
    component: WarrantyComponent,
    data: { mode: IMode.Registration },
    resolve: { warranty: WarrantyResolver },
  },
  {
    path: 'warranty/claim/:registrationId/:claimId',
    component: WarrantyComponent,
    data: { mode: IMode.Claim },
    resolve: { warranty: WarrantyResolver },
  },
  {
    path: 'warranty/claim/:registrationId',
    component: WarrantyComponent,
    data: { mode: IMode.Claim },
    resolve: { warranty: WarrantyResolver },
  },
  {
    path: 'warranty/:company/:constructionType',
    component: WarrantyComponent,
    data: { mode: IMode.Registration },
    resolve: { warranty: WarrantyResolver },
  },
  {
    path: 'find-claim',
    loadComponent: () => import('./components/find-claim/find-claim.component').then(m => m.FindClaimComponent),
  },
  {
    path: 'action-complete',
    loadComponent: () => import('./components/action-complete/action-complete.component').then(m => m.ActionCompleteComponent),
  },
  {
    path: 'action-complete/:company',
    loadComponent: () => import('./components/action-complete/action-complete.component').then(m => m.ActionCompleteComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },

];
